import { DateFilterOptionModel } from './date-filter-option.model';
import { dateFilterTypesEnum } from '../enums/date-filter-types.enum';
import { DateQueryTypeEnum } from '../../../api/mentions/enum/date-query-type.enum';

export const defaultDateFilterOptionsModel: DateFilterOptionModel[] = [
    {
        label: 'None',
        value:  null,
        type: dateFilterTypesEnum.none
    },
    {
        label: 'Today',
        value:  {
            type: DateQueryTypeEnum.RELATIVE,
            relativeStartOffsetH: 24,
            relativeEndOffsetH: 0
        },
        type: dateFilterTypesEnum.today
    },
    {
        label: 'Yesterday',
        value:  {
            type: DateQueryTypeEnum.RELATIVE,
            relativeStartOffsetH: 48,
            relativeEndOffsetH: 24
        },
        type: dateFilterTypesEnum.yesterday
    },
    {
        label: 'This week',
        value:  {
            type: DateQueryTypeEnum.RELATIVE,
            relativeStartOffsetH: 168,
            relativeEndOffsetH: 0
        },
        type: dateFilterTypesEnum.thisWeek
    },
    {
        label: 'Last week',
        value:  {
            type: DateQueryTypeEnum.RELATIVE,
            relativeStartOffsetH: 336,
            relativeEndOffsetH: 168
        },
        type: dateFilterTypesEnum.lastWeek
    },
    {
        label: 'Custom',
        value:  {
            type: DateQueryTypeEnum.ABSOLUTE,
            absoluteRange: {
                start: null,
                end: null
            }
        },
        type: dateFilterTypesEnum.custom
    },
];
